import type { ReactElement } from 'react';
import { ApiHealth } from './ApiHealth.tsx';
import './platform.css';

export const PLATFORM_SHORTCUTS: [string, string][] = [
  ['g then x', 'Go to API health'],
  ['1 / 2 / 3 / 4', 'API health: Endpoints, Findings, Proposals, Runs'],
  ['a / i', 'API health findings: acknowledge / ignore'],
];

export function platformPage(path: string): ReactElement | null {
  if (path === '/api-health') return <ApiHealth />;
  return null;
}
